<template>
  <div class="c">
    <Header/>
    <div class="container-fluid d-flex" style="padding: 0px; height: 100vh;">
      <div class="col-12 col-lg-8 col-xl-6 d-flex justify-content-center align-items-center get-in-touch">
        <div class="d-flex flex-column container-fluid col-10 col-md-8 p-0" style="box-shadow: 5px 5px 20px 5px #404040; background-color: white">
          <div class="d-flex justify-content-center align-items-center" style="width: 100%; background-color: #333333">
            <h1 class="p-3 m-0 title" style="font-family: Helvetica; color: #E0E0E0;">Get in touch with me !</h1>
          </div>
          <div class="pt-3 pb-3 pl-3 pr-3 pl-sm-5 pr-sm-5">
            <ContactMailSection b-color0="rgb(219,83,75,0.3)" b-color1="rgb(219,83,75,0.3)" b-color2="rgb(219,83,75,0)" v-bind:class="{yolo: hardmode}" image="shared/Misc_Email_Round.svg"/>
            <ContactSection b-color0="rgb(28,156,234,0.3)" b-color1="rgb(28,156,234,0.3)" b-color2="rgb(28,156,234,0)" v-bind:class="{yolo: hardmode}" image="shared/Twitter_cool.svg" text="@Huraleur" link="https://twitter.com/Huraleur"/>
            <ContactSection b-color0="rgb(10,102,194,0.3)" b-color1="rgb(10,102,194,0.3)" b-color2="rgb(10,102,194,0)" v-bind:class="{yolo: hardmode}" image="shared/Linkedin.svg" text="/hraguin" link="https://www.linkedin.com/in/hraguin/"/>
            <div class="d-flex align-items-center pt-3">
              <b-form-checkbox v-model="hardmode" switch size="lg" style="margin-right: 5px"></b-form-checkbox>
              <div class="hardmode-text">Hardmode</div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid p-0 d-flex col-lg-4 col-xl-6 justify-content-end" style="overflow: hidden">
        <img class="d-none d-lg-block" src="../assets/hc3p/HC3P_Screenshot_Cover_1.jpg" style="max-height: 100%; width: auto;">
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import ContactSection from "@/components/ContactSection";
import ContactMailSection from "@/components/ContactMailSection";
export default {
  name: "Contact",
  components: {ContactMailSection, ContactSection, Header},
  data(){
    return{
      hardmode: false
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.c{
  background-color: #fff4d9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(330,960,468)'%3E%3Cstop offset='0' stop-color='%23fff4d9'/%3E%3Cstop offset='1' stop-color='%23bae5ff'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='1252' height='1043.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

.bouh{
  background-image: linear-gradient(#5187c4, #1c2f45);
  background-size: auto 200%;
  background-position: 0 100%;
  transition: background-position 0.5s;

  height: 50px;
  width: 200px;

  /* ...and various other button styles */
}

.bouh:hover{
  background-position: 0 0;
}

.title{

  font-size: 1.2rem;

  @include media-breakpoint-up(sm) {
    font-size: 1.5rem;
  }

  @include media-breakpoint-up(md) {
    font-size: 2rem;
  }
}

.hardmode-text{
  font-size: 1rem;

  @include media-breakpoint-up(sm) {
    font-size: 1.1rem;
  }

  @include media-breakpoint-up(md) {
    font-size: 1.3rem;
  }
}

.get-in-touch{
  padding-left: 0px;
  @media screen and (min-width: 1600px){
    padding-left: 150px;
  }
}

.yolo{
  animation: 2s linear infinite;
  animation-name: yolo-animation;
}

@keyframes yolo-animation {
  0% {transform: rotate(0deg)}
  100%{transform: rotate(360deg)}
}

</style>